import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RadioButton } from "ui";

import { OrdersFilterGenderValues } from "../../../../orders.types";
import { FilterFormValues } from "../OrdersFilterForm.types";

import styles from "../OrdersFilterForm.module.scss";

const handleGenderChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  onChange: (value: string) => void
) => {
  onChange(String(e.currentTarget.value));
};

export const GenderBlock = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<FilterFormValues>();

  return (
    <div className={styles.orderFilterForm__block}>
      <h4 className={styles.orderFilterForm__block__title}>Gender</h4>

      <div className={styles.orderFilterForm__block__box}>
        <Controller
          control={control}
          name="gender"
          render={({ field: { value, onChange } }) => (
            <>
              <RadioButton
                checked={!value || value === OrdersFilterGenderValues.ALL}
                value={OrdersFilterGenderValues.ALL}
                onChange={(e) => handleGenderChange(e, onChange)}
                label={t("All")}
              />
              <RadioButton
                checked={value === OrdersFilterGenderValues.MALE}
                value={OrdersFilterGenderValues.MALE}
                onChange={(e) => handleGenderChange(e, onChange)}
                label={t("Male")}
              />
              <RadioButton
                checked={value === OrdersFilterGenderValues.FEMALE}
                value={OrdersFilterGenderValues.FEMALE}
                onChange={(e) => handleGenderChange(e, onChange)}
                label={t("Female")}
              />
            </>
          )}
        />
      </div>
    </div>
  );
};
